import "./Router.css";
import Home from "./Home";
import History from "./History";

function App() {
  const path = window.location.pathname;

  // switch case
  let component = null;
  switch (path) {
    case "/":
    case "/home":
      component = <Home />;
      break;
    case "/history":
      component = <History />;
      break;
  }

  return (
    <div className={`bg-background text-primary`}>
      <header className="nav-container container">
        <div>
          <span className="title">Photo Gallery</span>
        </div>
        <nav>
          <ul>
            <li>
              <a href="/home">Home Page</a>
            </li>
            <li>
              <a href="/history">Search History</a>
            </li>
          </ul>
        </nav>
      </header>

      <div className="container">{component}</div>
    </div>
  );
}

export default App;
